export enum ChoiceCustomerOrPhotographer {
  Myself = 'myself',
  Photographer = 'photographer',
}
